export const SERVER_ERROR_MSG =
  "Unable to submit your request due to a server error. If problem persists, contact Riverview";
export const SERVER_ERROR_TITLE = "Server Error";

export const RESEND_MULTIPLE_INVITES_SUCCESS_MESSAGE = "Invites have been sent";
export const RESEND_SINGLE_INVITEE_SUCCESS_MESSAGE = "Invite has been sent";
export const RESEND_MULTIPLE_INVITE_FAILED_MESSAGE = "Failed to resend invites";
export const RESEND_SINGLE_INVITE_FAILED_MESSAGE = "Failed to resend invite";
